export function exactPickerInstrument(results, rawQuery) {
  const query = String(rawQuery ?? "").trim();
  if (!query) return null;
  const upperQuery = query.toUpperCase();
  const exact = (results ?? []).filter((item) => (
    String(item?.code ?? "").trim().toUpperCase() === upperQuery
    || String(item?.name ?? "").trim() === query
  ));
  return exact.length === 1 ? exact[0] : null;
}

export function selectablePickerInstrument(results, rawQuery) {
  const exact = exactPickerInstrument(results, rawQuery);
  if (exact) return exact;
  const candidates = (results ?? []).filter(Boolean);
  return candidates.length === 1 ? candidates[0] : null;
}
